import { ProjectViewModel } from "../../../ViewModel/ProjectViewModel";
import { LtlPipelineViewModel } from "../../../ViewModel/LtlPipelineViewModel";
import { findByKey } from "../../../../Utils/arrays";
import { SpdrClientViewModel } from "../../../ViewModel/SpdrClientViewModel";
import { PdsrClientViewModel } from "../../../ViewModel/PdsrClientViewModel";

type Props = {
  projectToCheckFor: ProjectViewModel;
  selectedLtlPipeline: LtlPipelineViewModel | undefined;
};

export type LtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScopeProps = {
  isLtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope: boolean;
};

export const isLtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope = ({
  projectToCheckFor,
  selectedLtlPipeline,
}: Props) => {
  if (!selectedLtlPipeline) throw new Error("LTL Pipeline undefined");

  const ltlPipelineRoutings = selectedLtlPipeline.routing?.length === 0;

  const spdrOnProject = findByKey<SpdrClientViewModel>({
    list: projectToCheckFor.SpdrsOnThisProject,
    identifier: selectedLtlPipeline.SpdrId,
    keyOfType: "SpdrId",
  });

  const pdsrOnProject = findByKey<PdsrClientViewModel>({
    list: projectToCheckFor.PdsrsOnThisProject,
    identifier: selectedLtlPipeline.PdsrId,
    keyOfType: "PdsrId",
  });

  return spdrOnProject !== undefined
    ? ltlPipelineRoutings && !spdrOnProject.InScope
    : ltlPipelineRoutings && !pdsrOnProject?.InScope;
};
